import { NgModule } from '@angular/core';
import { redirectUnauthorizedTo, canActivate } from '@angular/fire/auth-guard';
import { RouterModule, Routes } from '@angular/router';

import { PlatinumGuard } from './shared/guards/platinum.guard';
import { OperatorGuard } from './shared/guards';
import { AtLeastInstallerGuard } from './shared/guards/at-least-installer.guard';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['auth/login']);

const routes: Routes = [
  {
    path: 'customer',
    redirectTo: 'customer/plants',
    pathMatch: 'full',
  },
  {
    path: 'customer',
    ...canActivate(redirectUnauthorizedToLogin),
    canActivate: [
      ...canActivate(redirectUnauthorizedToLogin).canActivate,
      PlatinumGuard,
    ],
    loadChildren: () => import('./customer/dashboard-page/dashboard.module').then((m) => m.DashboardPageModule),
  },
  {
    path: 'identity-registration',
    ...canActivate(redirectUnauthorizedToLogin),
    canActivate: [
      ...canActivate(redirectUnauthorizedToLogin).canActivate,
    ],
    loadChildren: () => import('./shared/pages/')
      .then((m) => m.IdentityPageModule),
  },
  {
    path: 'migration-request',
    ...canActivate(redirectUnauthorizedToLogin),
    canActivate: [
      ...canActivate(redirectUnauthorizedToLogin).canActivate,
      AtLeastInstallerGuard,
    ],
    loadChildren: () => import('./shared/pages/')
      .then((m) => m.MigrationRequestPageModule),
  },
  {
    path: 'service',
    ...canActivate(redirectUnauthorizedToLogin),
    canActivate: [
      ...canActivate(redirectUnauthorizedToLogin).canActivate,
      OperatorGuard,
    ],
    loadChildren: () => import('./service/dashboard-page/service-dashboard.module')
      .then((m) => m.ServiceDashboardPageModule),
  },
  {
    path: 'account-error',
    ...canActivate(redirectUnauthorizedToLogin),
    canActivate: [
      ...canActivate(redirectUnauthorizedToLogin).canActivate,
      PlatinumGuard,
    ],
    loadChildren: () => import('./shared/pages')
      .then((m) => m.ForbiddenPageModule),
  },
  {
    path: '',
    redirectTo: 'customer/plants',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    paramsInheritanceStrategy: 'always',
  })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
